"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPercentFormat = exports.prettyDoubleDigitPrecision = exports.toFormattedUSDKMOrB = exports.toDollarFormat = exports.joinWithAlternateTerminalSeparator = void 0;
const assert_1 = __importDefault(require("assert"));
const lodash_1 = __importDefault(require("lodash"));
/**
 * Used to join with an alternate separator for the last join
 * Can be used to produce a list such as the following: white, black, red, blue, and green
 * Notice how the last separator has an 'and' in the example above
 *
 * @param tokens a list of tokens to join together
 * @param separator the separator to be used for all joins except for the last one
 * @param alternateTerminalSeparator the separator to be used for the last join
 */
const joinWithAlternateTerminalSeparator = (tokens, separator, alternateTerminalSeparator) => {
    if (tokens.length === 1) {
        return tokens[0];
    }
    if (tokens.length === 2) {
        return tokens.join(alternateTerminalSeparator);
    }
    const leading = tokens.slice(0, -1);
    const lastPiece = tokens[tokens.length - 1];
    return [leading.join(separator), lastPiece].join(alternateTerminalSeparator);
};
exports.joinWithAlternateTerminalSeparator = joinWithAlternateTerminalSeparator;
const toDollarFormat = (amount, { showFractionZeros = true, maximumFractionDigits } = {}) => {
    const formatted = amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits,
    });
    if (showFractionZeros) {
        return formatted;
    }
    return formatted.replace(/\.00$/, '');
};
exports.toDollarFormat = toDollarFormat;
const toFormattedUSDKMOrB = (number, showFractionZeros = true, includePlusForPositive = false) => {
    if (number >= 1_000_000_000) {
        return `${includePlusForPositive ? '+' : ''}${(0, exports.toDollarFormat)(number / 1_000_000_000, { showFractionZeros })}B`;
    }
    else if (number >= 1_000_000) {
        return `${includePlusForPositive ? '+' : ''}${(0, exports.toDollarFormat)(number / 1_000_000, { showFractionZeros })}M`;
    }
    else if (number >= 1000) {
        return `${includePlusForPositive ? '+' : ''}${(0, exports.toDollarFormat)(number / 1000, { showFractionZeros })}K`;
    }
    else if (number >= 0) {
        return `${includePlusForPositive ? '+' : ''}${(0, exports.toDollarFormat)(number, { showFractionZeros })}`;
    }
    else if (number > -1000) {
        return `${(0, exports.toDollarFormat)(number, { showFractionZeros })}`;
    }
    else if (number > -1_000_000) {
        return `${(0, exports.toDollarFormat)(number / 1000, { showFractionZeros })}K`;
    }
    else if (number > -1_000_000_000) {
        return `${(0, exports.toDollarFormat)(number / 1_000_000, { showFractionZeros })}M`;
    }
    else {
        return `${(0, exports.toDollarFormat)(number / 1_000_000_000, { showFractionZeros })}B`;
    }
};
exports.toFormattedUSDKMOrB = toFormattedUSDKMOrB;
const prettyDoubleDigitPrecision = (num) => {
    return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
    });
};
exports.prettyDoubleDigitPrecision = prettyDoubleDigitPrecision;
/**
 * Converts a decimal to a percent. For example:
 * 0.01 ->      1%
 * 0.1 ->       10%
 * 0.11 ->      11%
 * 0.111 ->     11.1%
 * 0.1111 ->    11.11%
 * 0.11111 ->   11.11% (only up to 2 decimal places displayed)
 * 0.11115 ->   11.12% (after 2 decimal places, typical rounding rules apply)
 */
const toPercentFormat = (decimalFormat, maximumFractionDigits = 2) => {
    (0, assert_1.default)(typeof decimalFormat === 'number' && !lodash_1.default.isNaN(decimalFormat), `decimalFormat of ${decimalFormat} is not of type number`);
    return decimalFormat.toLocaleString('en-US', {
        style: 'percent',
        maximumFractionDigits,
    });
};
exports.toPercentFormat = toPercentFormat;
